import { Trans, useTranslation } from 'react-i18next';
import PaywallDescription from 'src/components/Paywall/PaywallDescription';
import { createCdnIcon } from 'src/designSystem/CdnIcon';
import { useCurrentUser } from 'src/queries/user';
import PanelHeader from 'src/designSystem/PanelHeader';
import { usePaywall } from 'src/contexts/PaywallContext';
import { isParentUser } from 'src/utils/userRole';

const GameControllerIcon = createCdnIcon('paywall/game-controller.svg');
const ThumbUpIcon = createCdnIcon('paywall/thumb-up.svg');
const MagicWandIcon = createCdnIcon('paywall/magic-wand.svg');
const StarIcon = createCdnIcon('paywall/star.svg');
const SmileyIcon = createCdnIcon('paywall/smiley.svg');

const ChildPaywallScreenDescription = () => {
  const { nbTrialDays } = usePaywall();
  const { data: user } = useCurrentUser();
  const isParent = isParentUser(user);
  const { t } = useTranslation();

  const titleEnhancementClassName =
    'bg-gradient-to-r bg-clip-text text-transparent from-paywall-darkest-from to-paywall-darkest-to';

  return (
    <>
      <PanelHeader
        title={
          isParent ? (
            <Trans i18nKey={`paywall.description.parent.title`}>
              Profitez de l’expérience Baobab
              <span className={titleEnhancementClassName}>sans limite !</span>
            </Trans>
          ) : (
            <Trans i18nKey={'paywall.description.child.title'}>
              Profitez de l’expérience Baobab
              <span className={titleEnhancementClassName}>sans limite !</span>
            </Trans>
          )
        }
        description={
          <>
            {isParent ? (
              <Trans
                i18nKey={`paywall.description.parent.subtitle`}
                values={{ nbTrialDays }}
              >
                <span className={'font-bold'}>
                  Testez 14 jours, c’est gratuit !
                </span>
              </Trans>
            ) : (
              <Trans i18nKey={'paywall.description.child.subtitle'}>
                <span className={'font-bold'}>24 heures d'essai gratuit</span>
              </Trans>
            )}
            <div>
              {isParent
                ? t(`paywall.description.parent.subtitle2`)
                : t('paywall.description.child.subtitle2')}
            </div>
          </>
        }
      />

      <div className={'flex flex-col gap-4 items-start'}>
        <PaywallDescription
          title={
            isParent
              ? t(`paywall.description.parent.item1.title`)
              : t('paywall.description.child.item1.title')
          }
          description={
            isParent
              ? t(`paywall.description.parent.item1.description`)
              : t('paywall.description.child.item1.description')
          }
          IconComponent={
            isParent ? MagicWandIcon : ThumbUpIcon
          }
        />
        <PaywallDescription
          title={
            isParent
              ? t(`paywall.description.parent.item2.title`)
              : t('paywall.description.child.item2.title')
          }
          description={
            isParent
              ? t(`paywall.description.parent.item2.description`)
              : t('paywall.description.child.item2.description')
          }
          IconComponent={
            isParent ? ThumbUpIcon : GameControllerIcon
          }
        />
        <PaywallDescription
          title={
            isParent
              ? t(`paywall.description.parent.item3.title`)
              : t('paywall.description.child.item3.title')
          }
          description={
            isParent
              ? t(`paywall.description.parent.item3.description`)
              : t('paywall.description.child.item3.description')
          }
          IconComponent={isParent ? SmileyIcon : StarIcon}
        />
      </div>
    </>
  );
};

export default ChildPaywallScreenDescription;
